import SpellList, { SpellListItem } from './SpellList';

export default SpellList;
export { SpellList, SpellListItem };
